"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutableRecordStore = exports.RecordStore = void 0;
var AbstractStore_1 = require("./AbstractStore");
var RecordStore = function (templateState) {
    var e_1, _a;
    var Impl = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
            _this.state = templateState;
            return _this;
        }
        return class_1;
    }(AbstractStore_1.AbstractStore));
    var _loop_1 = function (key) {
        Object.defineProperty(Impl.prototype, key, {
            configurable: false,
            get: function () {
                this.guardDestroyed();
                return (this.getState())[key];
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(templateState)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return Impl;
};
exports.RecordStore = RecordStore;
var MutableRecordStore = function (templateState) {
    var e_2, _a;
    var Impl = /** @class */ (function (_super) {
        __extends(class_2, _super);
        function class_2() {
            var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
            _this.state = templateState;
            return _this;
        }
        class_2.prototype.mutate = function (update) {
            return this.updateState(update);
        };
        class_2.prototype.mutateTo = function (newState) {
            this.setState(newState);
        };
        return class_2;
    }(AbstractStore_1.AbstractStore));
    var _loop_2 = function (key) {
        Object.defineProperty(Impl.prototype, key, {
            configurable: false,
            get: function () {
                this.guardDestroyed();
                return (this.getState())[key];
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(templateState)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_2(key);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return Impl;
};
exports.MutableRecordStore = MutableRecordStore;
